import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=2f54512f&scoped=true&lang=pug"
import script from "./baseLayout.vue?vue&type=script&lang=js"
export * from "./baseLayout.vue?vue&type=script&lang=js"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=2f54512f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54512f",
  null
  
)

export default component.exports